var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "38px",
    viewBox: "0 0 36 38",
    style: {
      enableBackground: "new 0 0 36 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ads_icon",
    transform: "translate(-32 -410)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_157",
    transform: "translate(32 429)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,19H2c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v15C10,18.1,9.1,19,8,19z M2,2L2,2v15h6V2H2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_158",
    transform: "translate(45 410)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,38H2c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v34C10,37.1,9.1,38,8,38z M2,2L2,2v34h6V2H2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_159",
    transform: "translate(58 421)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,27H2c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v23C10,26.1,9.1,27,8,27z M2,2L2,2v23h6V2H2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsicon);
export default __webpack_public_path__ + "static/media/adsicon.15987e7ebdeae7a5a899bbd7d55a7d03.svg";
export { ForwardRef as ReactComponent };